<woa-modal-page-layout [title]="'woa.heading.app-device-status.title'">
    @if (!appDeviceService.appDeviceStatus()) {
        <woa-content-message [level]="MessageLevel.WARNING"
                             [text]="'woa.error.app-device-status.noStatusDetails'"></woa-content-message>
    }
    @if (appDeviceService.appDeviceStatus()) {
        <div class="statuses">
            <div class="statuses-name">{{ 'woa.common.clientId' | translate }}</div>
            <div class="statuses-value">{{ configurationModel.clientId() }}</div>
            @if (appDeviceService.appDeviceStatus().identifiers) {
                @for (nameValue of appDeviceService.appDeviceStatus().identifiers; track nameValue) {
                    <div class="statuses-name">{{ nameValue.name }}</div>
                    <div class="statuses-value">{{ nameValue.value }}</div>
                }
            }
            @if (appDeviceService.appDeviceStatus().statuses) {
                @for (nameValue of appDeviceService.appDeviceStatus().statuses; track nameValue) {
                    <div class="statuses-name">{{ nameValue.name }}</div>
                    <div class="statuses-value">{{ nameValue.value }}</div>
                }
            }
        </div>
    }
    @if (appDeviceService.appDeviceStatus()) {
        <woa-button woa-page-footer-control
                    [label]="'woa.button.app-device-status.sendToChewzie'"
                    (onActivate)="sendStatus()"></woa-button>
    }
</woa-modal-page-layout>
